import React, { useState } from "react";

interface Header {
  key: string; // Unique identifier for the column
  label: string; // Display name for the column
  span: number; // Column span (for grid layout)
  sortable?: boolean; // Indicates if the column is sortable
}

interface TableHeaderProps {
  headers: Header[]; // Array of header definitions
  onSortChange?: (sortConfig: { key: string; direction: "asc" | "desc" } | undefined) => void; // Callback to update sort key and direction
  className?: string;
}

const TableHeader: React.FC<TableHeaderProps> = ({ headers, onSortChange, className }) => {
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: "asc" | "desc" } | undefined>(undefined);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleSort = (key: string) => {
    const newSortConfig: { key: string; direction: "asc" | "desc" } | undefined =
      sortConfig && sortConfig.key === key
        ? sortConfig.direction !== "desc"
          ? { key, direction: sortConfig.direction === "asc" ? "desc" : "asc" }
          : undefined
        : { key, direction: "asc" };

    setSortConfig(newSortConfig);

    if (onSortChange) {
      onSortChange(newSortConfig);
    }
  };

  const getArrow = (key: string) => {
    if (!sortConfig || sortConfig.key !== key) return "↕"; // Default unsorted state
    return sortConfig.direction === "asc" ? "↑" : "↓";
  };

  // return (
  //   <>
  //     <div className="hidden w-full pt-2 bg-white rounded md:block">
  //       <div className={`items-center grid gap-4 ${className}`}>
  //         {headers.map(header => (
  //           <div
  //             key={header.key}
  //             className={`col-span-${header.span} text-sm font-bold capitalize flex items-center ${
  //               header.sortable ? "cursor-pointer" : "cursor-default"
  //             }`}
  //             onClick={header.sortable ? () => toggleSort(header.key) : undefined}
  //           >
  //             {header.label} {header.sortable && <span className="pt-1 ml-1 text-xs">{getArrow(header.key)}</span>}
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   </>
  // );

  return (
    <div className="hidden w-full pt-2 bg-white rounded md:block">
      <div className={`grid gap-4 items-center ${className}`}>
        {headers.map(header => (
          <div
            key={header.key}
            className={`col-span-${header.span} text-sm font-bold capitalize flex items-center ${
              header.sortable ? "cursor-pointer" : "cursor-default"
            }`}
            onClick={header.sortable ? () => toggleSort(header.key) : undefined}
          >
            {header.label}
            {header.sortable && <span className="pt-[2px] ml-1 text-xs select-none">{getArrow(header.key)}</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TableHeader;
